<nz-layout class="app-layout">
  
  <nz-sider class="menu-sidebar " *ngIf="isLoggedIn"
            [nzCollapsible]="true"
            [(nzCollapsed)]="isCollapsed" 
            [nzTrigger]="siderTrigger"
            nzTheme="light"  >
    <app-sidenav [isCollapsed]="isCollapsed"></app-sidenav>
  </nz-sider>

  <ng-template #siderTrigger>
    <span class="sider-trigger-tooltip" [attr.data-tooltip]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'" [attr.aria-label]="isCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
      <span nz-icon [nzType]="isCollapsed ? 'right' : 'left'"></span>
    </span>
  </ng-template>



  <nz-layout>
    <!-- <nz-content> 
    </nz-content> -->



    <router-outlet></router-outlet>


    <!-- <nz-footer>Service Desk © 2023</nz-footer> -->
  </nz-layout>
</nz-layout>
